<template>
  <Row>
    <i-col span="24">
      <AffixHeader>
        <span slot="current">Events</span>
        <span slot="title">Events</span>
      </AffixHeader>

      <template v-if="$can('create', 'events')">
        <i-button type="primary" @click="$router.push('/events/new')">
          <FFIcon type="plus" />New Event
        </i-button>
        <br />
        <br />
      </template>

      <Card dis-hover>
        <h3 slot="title">Search</h3>
        <i-form :model="form" :label-width="90" label-position="right">
          <Row>
            <i-col span="12">
              <i-form-item label="Name" style="margin-right:6px;">
                <i-input v-model="form.name"></i-input>
              </i-form-item>
            </i-col>
            <i-col span="6">
              <i-form-item label="Country">
                <CountrySelect v-model="form.iso3" filterable multiple></CountrySelect>
              </i-form-item>
            </i-col>

            <i-col span="6">
              <i-form-item label="Region" style="margin-right:6px;">
                <i-select v-model="form.region" filterable multiple>
                  <i-option value="Latin America and the Caribbean">Latin America and the Caribbean</i-option>
                  <i-option value="North America">North America</i-option>
                  <i-option value="South Asia">South Asia</i-option>
                  <i-option value="Sub-Saharan Africa">Sub-Saharan Africa</i-option>
                  <i-option value="Middle East and North Africa">Middle East and North Africa</i-option>
                  <i-option value="East Asia and Pacific">East Asia and Pacific</i-option>
                  <i-option value="Europe and Central Asia">Europe and Central Asia</i-option>
                </i-select>
              </i-form-item>
            </i-col>
          </Row>

          <Row>
            <i-col span="12">
              <i-form-item label="Cause" style="margin-right:6px;">
                <i-select v-model="form.displacement_type" filterable multiple>
                  <i-option value="Conflict">Conflict</i-option>
                  <i-option value="Disaster">Disaster</i-option>
                  <i-option value="Development">Development</i-option>
                </i-select>
              </i-form-item>
            </i-col>

            <i-col span="12">
              <i-form-item label="Start Date">
                <Tooltip content="Double click for a single date." placement="top-start">
                  <DatePicker type="daterange" v-model="form.start_date" style="width:100%;"></DatePicker>
                </Tooltip>
              </i-form-item>
            </i-col>
          </Row>

          <Row>
            <i-col span="12">
              <i-form-item label="Year" style="margin-right:6px;">
                <i-select v-model="form.year" filterable multiple>
                  <i-option v-for="year in years" :key="year" :value="year">
                    {{
                    year
                    }}
                  </i-option>
                </i-select>
              </i-form-item>
            </i-col>
            <i-col span="12">
              <i-form-item label="Hazard Type">
                <Cascader
                  v-model="form.hazardtype"
                  :data="hazardTypes"
                  change-on-select
                  filterable
                  trigger="hover"
                ></Cascader>
              </i-form-item>
            </i-col>
          </Row>

          <Row type="flex" justify="end" style="margin:12px 0;">
            <i-form-item class="action-buttons">
              <i-button icon="search" @click="search">Search</i-button>
              <i-button icon="close" @click="reset">Reset</i-button>
            </i-form-item>
          </Row>
        </i-form>
      </Card>
      <br />
      <EventsTable :conditions="conditions"></EventsTable>
    </i-col>
  </Row>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import EventsTable from "@/events/table";
import CountrySelect from "@/components/country_select";
import { mapGetters, mapMutations } from "vuex";
import { getTsQueryValue } from "@/utils/common";

const emptyForm = {
  name: "",
  year: [],
  iso3: [],
  region: [],
  displacement_type: [],
  start_date: [],
  hazardtype: [],
};

export default {
  components: {
    EventsTable,
    CountrySelect,
  },

  data() {
    return {
      form: _.clone(emptyForm),
      conditions: {},
      hazardTypes: [
        {
          label: "Climatological",
          value: "Climatological",
          children: [
            {
              label: "Weather related",
              value: "Weather related",
              children: [
                {
                  label: "Drought",
                  value: "Drought",
                  children: [
                    {
                      id: 1,
                      label: "Drought",
                      value: "Drought",
                    },
                  ],
                },
                {
                  label: "Extreme temperature",
                  value: "Extreme temperature",
                  children: [
                    {
                      id: 5,
                      label: "Extreme temperature",
                      value: "Extreme temperature",
                    },
                    {
                      id: 6,
                      label: "Extreme temp, Extreme Heat / Heat Wave",
                      value: "Extreme temp, Extreme Heat / Heat Wave",
                    },
                    {
                      id: 7,
                      label: "Extreme temp, Winter Conditions / Cold Wave",
                      value: "Extreme temp, Winter Conditions / Cold Wave",
                    },
                    {
                      id: 8,
                      label: "Exterme temp, Severe winter conditions",
                      value: "Exterme temp, Severe winter conditions",
                    },
                  ],
                },
                {
                  label: "Wildfire",
                  value: "Wildfire",
                  children: [
                    {
                      id: 2,
                      label: "Wildfire",
                      value: "Wildfire",
                    },
                    {
                      id: 3,
                      label: "Wildfire - Forest",
                      value: "Wildfire - Forest",
                    },
                    {
                      id: 4,
                      label: "Wildfire - Land fire",
                      value: "Wildfire - Land fire",
                    },
                    {
                      id: 37,
                      label: "Wildfire - Firenado",
                      value: "Wildfire - Firenado",
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          label: "Meteorological",
          value: "Meteorological",
          children: [
            {
              label: "Weather related",
              value: "Weather related",
              children: [
                {
                  label: "Storm",
                  value: "Storm",
                  children: [
                    {
                      id: 32,
                      label: "Storm",
                      value: "Storm",
                    },
                    {
                      id: 33,
                      label: "Storm, Extra-tropical",
                      value: "Storm, Extra-tropical",
                    },
                    {
                      id: 34,
                      label: "Storm, Tropical",
                      value: "Storm, Tropical",
                    },
                    {
                      id: 35,
                      label: "Storm, Convective",
                      value: "Storm, Convective",
                    },
                    {
                      id: 36,
                      label: "Tornado",
                      value: "Tornado",
                    },
                    {
                      id: 38,
                      label: "Storm, Tropical, Hurricane",
                      value: "Storm, Tropical, Hurricane",
                    },
                    {
                      id: 39,
                      label: "Storm, Tropical, Cyclone",
                      value: "Storm, Tropical, Cyclone",
                    },
                    {
                      id: 40,
                      label: "Hailstorm",
                      value: "Hailstorm",
                    },
                    {
                      id: 41,
                      label: "Winter storm",
                      value: "Winter storm",
                    },
                    {
                      id: 42,
                      label: "Thunderstorm",
                      value: "Thunderstorm",
                    },
                    {
                      id: 43,
                      label: "Nor'wester",
                      value: "Nor'wester",
                    },
                    {
                      id: 45,
                      label: "Storm, Storm surge",
                      value: "Storm, Storm surge",
                    },
                    {
                      id: 46,
                      label: "Storm, Tropical, Typhoon",
                      value: "Storm, Tropical, Typhoon",
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          label: "Hydrological",
          value: "Hydrological",
          children: [
            {
              label: "Weather related",
              value: "Weather related",
              children: [
                {
                  label: "Flood",
                  value: "Flood",
                  children: [
                    {
                      id: 22,
                      label: "Flood",
                      value: "Flood",
                    },
                    {
                      id: 23,
                      label: "Flash flood",
                      value: "Flash flood",
                    },
                    {
                      id: 24,
                      label: "Coastal flood",
                      value: "Coastal flood",
                    },
                    {
                      id: 25,
                      label: "Riverine flood",
                      value: "Riverine flood",
                    },
                    {
                      id: 26,
                      label: "Ice jam flood",
                      value: "Ice jam flood",
                    },
                    {
                      id: 27,
                      label: "Dam release flood",
                      value: "Dam release flood",
                    },
                  ],
                },
                {
                  label: "Wet mass movement",
                  value: "Wet mass movement",
                  children: [
                    {
                      id: 28,
                      label: "Wet mass movement",
                      value: "Wet mass movement",
                    },
                    {
                      id: 29,
                      label: "Landslide, Avalanche",
                      value: "Landslide, Avalanche",
                    },
                    {
                      id: 30,
                      label: "Wave action, Rogue wave",
                      value: "Wave action, Rogue wave",
                    },
                    {
                      id: 31,
                      label: "Wave action, Seiche",
                      value: "Wave action, Seiche",
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          label: "Geophysical",
          value: "Geophysical",
          children: [
            {
              label: "Geophysical",
              value: "Geophysical",
              children: [
                {
                  label: "Mass movement",
                  value: "Mass movement",
                  children: [
                    {
                      id: 44,
                      label: "Glacial Lake Outburst Floods (GLOF)",
                      value: "Glacial Lake Outburst Floods (GLOF)",
                    },
                  ],
                },
                {
                  label: "Volcanic eruption",
                  value: "Volcanic eruption",
                  children: [
                    {
                      id: 16,
                      label: "Volcanic eruption",
                      value: "Volcanic eruption",
                    },
                    {
                      id: 17,
                      label: "Volcanic activity, Ash fall",
                      value: "Volcanic activity, Ash fall",
                    },
                    {
                      id: 18,
                      label: "Volcanic activity, Lahar",
                      value: "Volcanic activity, Lahar",
                    },
                    {
                      id: 19,
                      label: "Volcanic activity, Pyroclastic flow",
                      value: "Volcanic activity, Pyroclastic flow",
                    },
                    {
                      id: 20,
                      label: "Volcanic activity, Lava flow",
                      value: "Volcanic activity, Lava flow",
                    },
                    {
                      id: 21,
                      label: "Volcanic activity, Toxic gases",
                      value: "Volcanic activity, Toxic gases",
                    },
                  ],
                },
                {
                  label: "Dry mass movement",
                  value: "Dry mass movement",
                  children: [
                    {
                      id: 9,
                      label: "Dry mass movement",
                      value: "Dry mass movement",
                    },
                    {
                      id: 10,
                      label: "Mass movement, Sudden subsidence/sinkhole",
                      value: "Mass movement, Sudden subsidence/sinkhole",
                    },
                    {
                      id: 11,
                      label: "Mass movement, Landslide",
                      value: "Mass movement, Landslide",
                    },
                    {
                      id: 12,
                      label: "Mass movement, Rock fall",
                      value: "Mass movement, Rock fall",
                    },
                  ],
                },
                {
                  label: "Earthquake",
                  value: "Earthquake",
                  children: [
                    {
                      id: 13,
                      label: "Earthquake",
                      value: "Earthquake",
                    },
                    {
                      id: 14,
                      label: "Earthquake, Ground Shaking",
                      value: "Earthquake, Ground Shaking",
                    },
                    {
                      id: 15,
                      label: "Earthquake, Tsunami",
                      value: "Earthquake, Tsunami",
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    };
  },
  created() {
    if (this.searches["events"]) {
      this.form = this.searches["events"];
      this.search();
    }
  },
  computed: {
    ...mapGetters(["searches"]),
    years() {
      const currYear = new Date().getFullYear();
      return _.range(currYear, 1950, -1);
    },
  },
  methods: {
    ...mapMutations(["setSearch"]),
    debug(value) {
      console.log(value);
    },
    search() {
      let conditions = {};

      // Name
      if (this.form.name !== "") {
        conditions["name"] = getTsQueryValue(this.form.name)
      }

      let orConditions = [];

      // iso3
      if (this.form.iso3.length > 0) {
        let criteria = this.form.iso3.map(iso => `iso3.cs.{${iso}}`);
        orConditions = orConditions.concat(criteria);
      }

      // region
      if (this.form.region.length > 0) {
        let criteria = this.form.region.map(region => `region.cs.{${region}}`);
        orConditions = orConditions.concat(criteria);
      }

      if (orConditions.length > 0) {
        conditions["or"] = `(${orConditions.join(",")})`;
      }

      // Displacement Type
      if (this.form.displacement_type.length > 0) {
        conditions["displacement_type"] =
          "in.(" + this.form.displacement_type.toString() + ")";
      }

      // Year
      if (this.form.year.length > 0) {
        conditions["year"] = "in.(" + this.form.year.toString() + ")";
      }

      // Start date
      if (this.form.start_date.length > 0) {
        const start = moment(this.form.start_date[0]);
        const end = moment(this.form.start_date[1]);
        if (start.isValid() && start.isValid()) {
          conditions["and"] = `(start_date.gte.'${start.format(
            "YYYY-MM-DD"
          )}',start_date.lte.'${end.format("YYYY-MM-DD")}')`;
        }
      }

      // Hazard type
      if (this.form.hazardtype.length > 0) {
        const ht = this.form.hazardtype;
        const fields = ["category", "subcategory", "type", "subtype"];
        const field = fields[ht.length - 1];
        const value = ht[ht.length - 1];
        conditions[field] = `eq.${value}`;
      }

      this.conditions = conditions;
      this.setSearch({ type: "events", data: this.form });
    },

    reset() {
      this.form = _.clone(emptyForm);
      this.conditions = {};
      this.setSearch({ type: "events", data: null });
    },
  },
};
</script>

<style lang="css">
.ivu-tooltip {
  width: 100%;
}

.ivu-tooltip-rel {
  width: 100%;
}
</style>
